class LoadMore extends HTMLElement {
  constructor() {
    super();
    this._button = this.querySelector('button');
    this._page = 2;
    this._isLoading = false;
    this._sectionId = this.dataset.sectionId;
    this._productGrid = document.querySelector('#product-list-' + this._sectionId);
    this._loadedProductCount = this.querySelector('#product-count');
    this._collectionCount = this._loadedProductCount?.getAttribute('data-collection-product-count') || 0;
    this._productPerPage = this._loadedProductCount?.getAttribute('data-product-per-page') || 0;
    this._loadMoreCount = this.querySelector('#load-more-count');
    this._viewAllButton = this.querySelector('#collection-view-all');
  }

  connectedCallback() {
    if (this._button) {
      this.bindEvent();
    } else {
      console.log('No load-more button');
    }
  }

  addParamsToUrl(url, params) {
    // Create a URL object
    let urlObj = new URL(url, window.location.origin);

    // Get the current search params of the URL
    let searchParams = urlObj.searchParams;

    // Iterate over the params object and add each key-value pair to the searchParams
    for (let key in params) {
      searchParams.set(key, params[key]);
    }

    // The updated URL string will be in the href property
    return urlObj.href;
  }

  bindEvent() {
    // console.log('bind');
    this._productGrid = document.querySelector('#product-list-' + this._sectionId);
    if (this._loadedProductCount) {
      this._loadedProductCount.innerHTML = this._productGrid.querySelectorAll('.product-card').length;
    }

    // Load More button
    if (this._button) {
      this._button.addEventListener('click', () => {
        this.expandShowMore();
      });
    }

    // View All button
    if (this._viewAllButton) {
      this._viewAllButton.addEventListener('click', () => {
        this.loadAllProducts();
      });
    }
  }

  expandShowMore() {
    if (this._isLoading) return;
    this._isLoading = true;

    const queryString = window.location.search;

    const searchParams = new URLSearchParams(window.location.search);
    const url = this.getAttribute('collection-handle') + '?' + searchParams;

    //grab current filters & params
    let paramsObj = {};

    paramsObj['page'] = this._page;
    const newURL = this.addParamsToUrl(url, paramsObj);
    //  console.log(paramsObj);
    //  console.log(newURL)

    fetch(newURL)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const products = html.querySelector('#product-list-' + this._sectionId).children;

        Array.from(products).forEach((product) => {
          this._productGrid.appendChild(product);
        });

        const totalLoaded = this._productGrid.querySelectorAll('.product-card').length;
        const remaining = this._collectionCount - totalLoaded;

        if (this._loadMoreCount) {
          if (remaining > 0) {
            this._loadMoreCount.innerHTML = Math.min(this._productPerPage, remaining);
          } else {
            if (this._button) {
              this._button.classList.add('hidden');
            }
            if (this._viewAllButton) {
              this._viewAllButton.classList.add('hidden');
            }
          }
        }

        this._page++;
        this._isLoading = false;
        if (this._loadedProductCount) {
          this._loadedProductCount.innerHTML = totalLoaded;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  async loadAllProducts() {
    if (this._isLoading) return;
    this._isLoading = true;

    // Hide both buttons while loading
    if (this._button) {
      this._button.classList.add('hidden');
    }
    if (this._viewAllButton) {
      this._viewAllButton.classList.add('hidden');
    }

    try {
      while (true) {
        const searchParams = new URLSearchParams(window.location.search);
        const url = this.getAttribute('collection-handle') + '?' + searchParams;
        const paramsObj = { page: this._page };
        const newURL = this.addParamsToUrl(url, paramsObj);

        const response = await fetch(newURL);
        const responseText = await response.text();
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const products = html.querySelector('#product-list-' + this._sectionId).children;

        // If no more products, break the loop
        if (products.length === 0) break;

        Array.from(products).forEach((product) => {
          this._productGrid.appendChild(product);
        });

        this._page++;

        const totalLoaded = this._productGrid.querySelectorAll('.product-card').length;
        if (this._loadedProductCount) {
          this._loadedProductCount.innerHTML = totalLoaded;
        }

        const totalCollectionCount = Number(this._collectionCount);
        if (Number.isFinite(totalCollectionCount) && totalCollectionCount > 0 && totalLoaded >= totalCollectionCount) {
          break;
        }
      }
    } catch (e) {
      console.error('Error loading all products:', e);

      // Restore buttons if error loading all products
      if (this._productGrid.querySelectorAll('.product-card').length < this._collectionCount) {
        if (this._button) {
          this._button.classList.remove('hidden');
        }
        if (this._viewAllButton) {
          this._viewAllButton.classList.remove('hidden');
        }

        // Update remaining count
        if (this._loadMoreCount) {
          const remaining = this._collectionCount - this._productGrid.querySelectorAll('.product-card').length;
          this._loadMoreCount.innerHTML = Math.min(this._productPerPage, remaining);
        }
      }
    } finally {
      this._isLoading = false;

      const totalCollectionCount = Number(this._collectionCount);
      const totalLoaded = this._productGrid ? this._productGrid.querySelectorAll('.product-card').length : 0;

      if (Number.isFinite(totalCollectionCount) && totalCollectionCount > 0 && totalLoaded < totalCollectionCount) {
        this._button?.classList.remove('hidden');
        this._viewAllButton?.classList.remove('hidden');
      }
    }
  }
}

customElements.define('load-more', LoadMore);
